/**
 * PWA 状态检测工具
 *
 * @deprecated 此文件已废弃，请使用 platformUtils.ts 中的统一平台工具
 * 为了向后兼容性，此文件重新导出 platformUtils 中的相关函数
 */

import {
  isPWAMode,
  isPwaInstallSupported,
  hasRegisteredServiceWorker,
  getPwaStatus as getPlatformPwaStatus,
  watchPwaInstallStatus
} from './platformUtils';

/**
 * @deprecated 请使用 platformUtils.isPWAMode()
 */
export function isPwaMode(): boolean {
  return isPWAMode();
}

/**
 * @deprecated 请使用 platformUtils.isPwaInstallSupported()
 */
export { isPwaInstallSupported };

/**
 * @deprecated 请使用 platformUtils.hasRegisteredServiceWorker()
 */
export { hasRegisteredServiceWorker };

/**
 * @deprecated 请使用 platformUtils.getPwaStatus()
 */
export async function getPwaStatus(): Promise<{
  isPwaMode: boolean;
  isInstallSupported: boolean;
  hasServiceWorker: boolean;
  displayMode: string;
}> {
  const status = await getPlatformPwaStatus();
  return {
    isPwaMode: status.isPwaMode,
    isInstallSupported: status.isInstallSupported,
    hasServiceWorker: status.hasServiceWorker,
    displayMode: status.displayMode
  };
}

/**
 * @deprecated 请使用 platformUtils.watchPwaInstallStatus()
 */
export { watchPwaInstallStatus };
